import { default as authenticateConfiguration } from './authenticate';
import { default as clearSessionConfiguration } from './clearSession';
import { default as loginConfiguration } from './login';
import { default as logoutConfiguration } from './logout';
import { default as logoutMockUserConfiguration } from './logoutMockUser';

export const configurations = [
  loginConfiguration,
  logoutConfiguration,
  authenticateConfiguration,
  clearSessionConfiguration,
  logoutMockUserConfiguration
]


// WEBPACK FOOTER //
// ./src/state/modules/session/configurations/index.js